/* This file was generated automatically. Do not edit manually. */

export enum FormulaType {
    Constant = 'Constant',
    Variable = 'Variable',
    Negation = 'Negation',
    Conjunction = 'Conjunction',
    Disjunction = 'Disjunction',
}
